"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectDocumentColors = exports.setBg = exports.getActiveBg = exports.setFg = exports.getActiveFg = exports.setMarkColor = exports.getActiveMarkColor = void 0;
const slate_1 = require("slate");
const getActiveMarkColor = (editor) => {
    const marks = slate_1.Editor.marks(editor);
    const value = marks?.mark;
    if (value === false || value === undefined)
        return undefined;
    return value;
};
exports.getActiveMarkColor = getActiveMarkColor;
const setMarkColor = (editor, color) => {
    const current = (0, exports.getActiveMarkColor)(editor);
    const normalized = current === true ? 'yellow' : current;
    if (color === undefined || normalized === color)
        slate_1.Editor.removeMark(editor, 'mark');
    else
        slate_1.Editor.addMark(editor, 'mark', color);
};
exports.setMarkColor = setMarkColor;
const getActiveFg = (editor) => {
    const marks = slate_1.Editor.marks(editor);
    return marks?.fg;
};
exports.getActiveFg = getActiveFg;
const setFg = (editor, color) => {
    if (!color)
        slate_1.Editor.removeMark(editor, 'fg');
    else
        slate_1.Editor.addMark(editor, 'fg', color);
};
exports.setFg = setFg;
const getActiveBg = (editor) => {
    const marks = slate_1.Editor.marks(editor);
    return marks?.bg;
};
exports.getActiveBg = getActiveBg;
const setBg = (editor, color) => {
    if (!color)
        slate_1.Editor.removeMark(editor, 'bg');
    else
        slate_1.Editor.addMark(editor, 'bg', color);
};
exports.setBg = setBg;
const collectDocumentColors = (editor, key, limit = 10) => {
    const seen = new Set();
    for (const [node] of slate_1.Node.texts(editor)) {
        const value = node[key];
        if (typeof value === 'string' && value) {
            seen.add(value);
            if (seen.size >= limit)
                break;
        }
    }
    return Array.from(seen);
};
exports.collectDocumentColors = collectDocumentColors;
